import { TypographyComponent } from 'src/components/Typography'
import styled, { css } from 'styled-components'

export const ContainerManutencao = styled('div')(
  () => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0 auto;
    max-width: 80rem;
  `
)

export const Text = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-weight: 400;
      font-size: ${theme.typograph.fontsize.h7};
      color: ${theme.colors.base.blue100};
      text-align: center;

      span {
        font-weight: 700;
        font-size: ${theme.typograph.fontsize.h9};
      }
    }
  `
)
